export enum STORAGE_KEYS {
    FILTERS = 'filters',
}
